export enum ENTITY_COLUMNS {
  NAME = "Name",
  CITY = "City",
  COUNTRY = "Country",
  INDUSTRY = "Industry",
  CLIENT_ENTITY_ID = "Client Entity ID"
}

export interface EntitySort {
  sortColumn: ENTITY_COLUMNS;
  sortAscending: boolean;
}

export interface Pagination {
  selected?: number;
}

export interface Search {
  query?: string;
}



// WEBPACK FOOTER //
// ./src/entityList/types.ts